import { render } from "./reset-success.vue?vue&type=template&id=54098a9c&ts=true"
import script from "./reset-success.vue?vue&type=script&lang=ts"
export * from "./reset-success.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__